module.exports = __webpack_public_path__ + "fonts/CabinetGrotesk-Light.02f87914.eot";